import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable()
export class CompanyCertificatesProvider {
    constructor(private http: HttpClient) {}

    getCertificatesRequest(slug: string | number, params?: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/requests/${slug}`, {params})
            .pipe(map((data: any) => data));
    }

    create(slug: string | number, params: any): Observable<any> {
        return this.http
            .post(`${environment.envVar.API_URL}/xertify/requests/generate`, params)
            .pipe(map((data) => data));
    }

    getCertificates(slug: string | number, params?: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/transactions/${slug}`, {params})
            .pipe(map((data: any) => data));
    }

    getTemplates(slug: string | number, params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/templates/${slug}`, {params})
            .pipe(map((data: any) => data));
    }

    setTemplates(params: any): Observable<any> {
        return this.http
            .post(
                `${environment.envVar.API_URL}/xertify/templates/create`,
                params
            )
            .pipe(map((data: any) => data));
    }

    updateTemplate(params: any, templateId: any): Observable<any> {
        return this.http
            .put(
                `${environment.envVar.API_URL}/xertify/templates/update/${templateId}`,
                params
            )
            .pipe(map((data: any) => data));
    }

    deleteTemplate(templateId: any): Observable<any> {
        return this.http
            .delete(
                `${environment.envVar.API_URL}/xertify/templates/${templateId}`
            )
            .pipe(map((data: any) => data));
    }


    toggleTemplateStatus(templateId: any): Observable<any> {
        return this.http
            .put(
                `${environment.envVar.API_URL}/xertify/templates/${templateId}/change-status`,
                null
            )
            .pipe(map((data: any) => data));
    }

    updateTransaction(slug: string | number, params: any): Observable<any> {
        return this.http
            .put(
                `${environment.envVar.API_URL}/xertify/requests/update/${slug}`,
                params
            )
            .pipe(map((data: any) => data));
    }

    sendTransaction(slug: string | number, params: any): Observable<any> {
        return this.http
            .put(
                `${environment.envVar.API_URL}/xertify/requests/resend/${slug}`,
                params
            )
            .pipe(map((data: any) => data));
    }

    getFilter( params?: any): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/xertify/filters?place=transactions`, {params}).pipe(
            map((data: any) => data)
        );
    }

    getFilterCertificates( params?: any): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/xertify/filters?place=certificates`, {params}).pipe(
            map((data: any) => data)
        );
    }

    getCertificatesRequestFiltered(slug: string | number, filter?: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/requests/${slug}?filter=${filter?.filter}&value=${filter?.value}`)
            .pipe(map((data: any) => data));
    }

    getCertificatesRequestPaginated(slug: string | number, params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/requests/${slug}`, {params} )
            .pipe(map((data: any) => data));
    }


    getCertificatesFiltered(slug: string | number, filter?: any): Observable<any> {        
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/requests/${slug}?filter=${filter?.filter}&value=${filter?.value}`)
            .pipe(map((data: any) => data));
    }

    getCertificatesFilteredTransactions(slug: string | number, filter?: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/transactions/${slug}?filter=${filter?.filter}&value=${filter?.value}`)
            .pipe(map((data: any) => data));
    }

    getCertificatesPaginated(slug: string | number, params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/requests/${slug}`, {params})
            .pipe(map((data: any) => data));
    }

    getCertificatesPaginatedTransactions(slug: string | number, params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/transactions/${slug}`, {params})
            .pipe(map((data: any) => data));
    }


    revokeCertificate( params: any ): Observable<any> {
        return this.http
            .put(
                `${environment.envVar.API_URL}/xertify/transactions/certificate/revoke`, params,
                params
            )
            .pipe(map((data: any) => data));
    }

    downloadCertificate(params: any, fileName: string): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/xertify/transactions/certificate/download`, {responseType: 'blob', params}).pipe(
            map(data => {
                       
        const blob = new Blob([data], { type: 'text/pdf' });
     
        const url = window.URL.createObjectURL(blob);

  
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.pdf`; 


        document.body.appendChild(a);

        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
            })
        );
    }

    sendCertificate(params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/xertify/transactions/certificate/send/${params}`,)
            .pipe(map((data: any) => data));
    }

    // ==================== POK ENDPOINTS ====================

    getPokTemplates(companyId: string, params: any): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/pok/templates/${companyId}`, { params })
            .pipe(map((data: any) => data));
    }

    /**
     * Campos personalizados que declara una plantilla de POK.
     *
     * Alimenta el selector de "Campo Pok": antes se escribia a mano y un typo no daba error al
     * guardar sino que hacia fallar la emision entera despues, cuando POK la rechazaba.
     *
     * La respuesta trae `available`: en false significa que no se pudo consultar a POK y el
     * formulario debe caer al input de texto libre en vez de bloquear la configuracion.
     */
    getPokTemplateFields(companyId: string, pTemplateId: string): Observable<any> {
        return this.http
            .get(`${environment.envVar.API_URL}/pok/templates/${companyId}/fields`, {
                params: { p_template_id: pTemplateId },
            })
            .pipe(map((data: any) => data));
    }

    createPokTemplate(params: any): Observable<any> {
        return this.http
            .post(`${environment.envVar.API_URL}/pok/templates/create`, params)
            .pipe(map((data: any) => data));
    }

    updatePokTemplate(params: any, templateId: number): Observable<any> {
        return this.http
            .put(`${environment.envVar.API_URL}/pok/templates/update/${templateId}`, params)
            .pipe(map((data: any) => data));
    }

    deletePokTemplate(templateId: number): Observable<any> {
        return this.http
            .delete(`${environment.envVar.API_URL}/pok/templates/${templateId}`)
            .pipe(map((data: any) => data));
    }

    togglePokTemplateStatus(templateId: number): Observable<any> {
        return this.http
            .put(`${environment.envVar.API_URL}/pok/templates/${templateId}/change-status`, null)
            .pipe(map((data: any) => data));
    }
}
